import { DataTable } from "@/components/data-table";
import { formatDate, formatNumber } from "@/shared/formats";
import { ArticuloTransferencia } from "@/shared/types/articulo-transferencia";
import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export default function ArticuloTransferenciaView({
    articuloTransferencia
}: {
    articuloTransferencia: ArticuloTransferencia
}) {
    return <Stack gap={3} padding={3} flex={1}>
        <Stack gap={2}>
            <Typography variant="h6">Información General</Typography>
            <AttributeValuePair label={"Fecha: "} value={formatDate(articuloTransferencia.fecha)} />
        </Stack>
        <Stack gap={2} flex={1}>
            <Typography variant="h6">Artículos</Typography>
            <DataTable flex={1}>
                <DataTable.Content
                    fit="flex"
                    columns={[
                        { header: "Código", render: i => i.articuloCodigo },
                        { header: "Artículo", render: i => i.articuloNombre },
                        { header: "Cantidad (Uds.)", render: i => formatNumber(i.cantidad), align: "right" }
                    ]}
                    rows={articuloTransferencia.items}
                />
            </DataTable>
        </Stack>
    </Stack>
}

function AttributeValuePair({
    label,
    value
}: {
    label: ReactNode,
    value: ReactNode
}) {
    return <Stack direction={"row"} gap={2} marginLeft={5}>
        <Typography variant="subtitle2">{label}</Typography>
        <Typography variant="body2">{!value && value !== 0 ? "---" : value}</Typography>
    </Stack>
}
